/** 作品画板固定英文：供模板 v-bind 使用，不随站点 i18n 或浏览器翻译变化。 */
export const DECK_COPY_ATTRS = {
  lang: 'en',
  translate: 'no',
} as const;
